import { countries, CountryCode, countryData } from "DataMapper/CountryCode"
import { FunctionComponent, useEffect, useRef, useState } from "react"

interface Props {
  country: string
  changeCountry: (country: CountryCode) => void
}

const CountryCodeSelector: FunctionComponent<Props> = ({
  country,
  changeCountry,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="flex items-center w-full" ref={dropdownRef}>
      {/* Selected item display */}
      <div
        className="flex items-center w-full cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={countryData[country as CountryCode].flag}
          width={28}
          height={20}
          alt={country}
          className="rounded-[3px] mr-2"
        />
        <span className="text-[16px]">
          +{countryData[country as CountryCode].code}
        </span>

        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`ml-2 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="black"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Dropdown menu - positioned fixed to make it appear over everything */}
      {isOpen && (
        <div className="absolute top-[110%] left-0 w-full max-h-[200px] overflow-y-scroll z-[9999999] bg-white shadow-lg rounded-[8px] border border-[#C6CBD2] border-solid">
          {countries.map((option) => (
            <div
              key={option.value}
              className={`flex items-center justify-between px-3 py-3 cursor-pointer ${
                option.value === country ? "bg-[#ececec]" : "hover:bg-[#f8f8f8]"
              }`}
              onClick={() => {
                changeCountry(option.value as CountryCode)
                setIsOpen(false)
              }}
            >
              <div className="flex items-center">
                <img
                  src={countryData[option.value as CountryCode].flag}
                  width={28}
                  height={20}
                  alt={option.label}
                  className="rounded-[3px]"
                />
                <span className="pl-2 text-base">{option.label}</span>
              </div>
              <span className="text-base">
                +{countryData[option.value as CountryCode].code}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CountryCodeSelector
